export default {
      id: "icon-bool-intersect-usage",
      viewBox: "0 0 17 15",
      url: "/" + "assets/sprite.svg#icon-bool-intersect",
      toString: function () {
        return this.url;
      }
    }